import { useTranslation } from "react-i18next"
import { CheckBox, CheckBoxProps } from "../checkBox/CheckBox"
import './TermCheckBox.css'
import { ReactComponent as IcNext } from '../../assets/icon/ic_next_24.svg'
import { BottomSheet } from "../bottomSheet/BottomSheet"
import { useState } from "react"
import { Button } from "../button/Button"

interface TermCheckBoxProps extends CheckBoxProps {
    isRequired?: boolean;
    requiredLabel?: string;
    termsTitle?: string;
    termsContent?: string;
    isDetailLoading?: boolean;
    onOpenDetail?: () => void;
    onAgree?: () => void;
}

export const TermCheckBox = ({
    isRequired,
    requiredLabel,
    termsTitle,
    termsContent,
    isDetailLoading = false,
    onOpenDetail,
    onAgree,
    ...rest
}: TermCheckBoxProps) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenDetail = () => {
        setIsOpen(true);
        onOpenDetail?.();
    };

    const handleCloseDetail = () => {
        setIsOpen(false);
    };

    const handleAgree = () => {
        setIsOpen(false);
        rest.setChecked(true);
        onAgree?.();
    };

    return (
        <div className="term-checkbox">
            <span style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "4px"}}>
                <CheckBox
                    {...rest}
                />
                {isRequired &&
                    <span className="required">{requiredLabel || t("required")}</span>
                }
            </span>
            <IcNext
                className="ic-open-term"
                onClick={handleOpenDetail}
                height="20px"
                width="20px"
            />
            <BottomSheet
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div className="term-container">
                    <div className="term-info">
                        <div className="term-title">
                            {termsTitle || rest.title}
                        </div>
                        {isDetailLoading ? (
                            <div className="term-text">{t("common.loading")}</div>
                        ) : termsContent ? (
                            <div
                                className="term-text"
                                dangerouslySetInnerHTML={{ __html: termsContent }}
                            />
                        ) : (
                            <div className="term-text" />
                        )}
                    </div>
                    <div className="term-btn-container">
                        <Button
                            buttonColor="var(--fixedBlack)"
                            text={t("term.btnClose")}
                            onPress={handleCloseDetail}
                        />
                        <Button
                            text={t("term.btnAgree")}
                            onPress={handleAgree}
                        />
                    </div>
                </div>
            </BottomSheet>
        </div>
    )
}
